import checkServiceStatus from '@/lib/helpers/check-service-status';
import getLastEditValue from '@/forms/helpers/get-last-edit-value';

import {
  SERVICE_STATUS,
} from '@/forms/constants/services';

const validService = (serviceName, fieldName) => (value) => {
  const lastValue = getLastEditValue(fieldName);
  if (value === lastValue) {
    const serviceStatus = checkServiceStatus(serviceName);
    if (serviceStatus === SERVICE_STATUS.fail) {
      return false;
    }
  }
  return true;
};

export default validService;
